const floatinputboxes = document.querySelectorAll('.radio-box-dekaz')
if(floatinputboxes) {
    floatinputboxes.forEach(inputbox => {
        const sels = inputbox.querySelectorAll('input[type="radio"]')
        const res = inputbox.querySelector('input[type="hidden"]')
        sels.forEach(sel => {
            sel.addEventListener('click', ()=>{
                // console.log(sel.value)
                res.value = sel.value
                
            })
        })  
    })
}